import { Link } from "react-router-dom";

export function Logo({ light = false, className = "", compact = false }) {
  return (
    <Link to="/" aria-label="Emini Reinigung – Startseite" data-testid="nav-brand-logo" className={`flex items-center ${className}`}>
      <img
        src={light ? "/logo-white.png" : "/logo.png"}
        alt="Emini Reinigung"
        width={1470}
        height={355}
        className={`transition-all duration-500 ease-out ${compact ? "h-8" : "h-9 md:h-11"} w-auto`}
      />
    </Link>
  );
}
